import React from "react";
import { useLocation } from "react-router-dom";
import { FREIGHTS, TRANSPORT } from "helpers/routes";
import AppDownload from "./AppDownload";
import FooterNav from "./FooterNav";
import SocialLinks from "./SocialLinks";
import Copyright from "./Copyright";
import styles from "./footer.module.scss";

const HIDDEN_ROUTES = [FREIGHTS.search, TRANSPORT.search];

const Footer = () => {
    const { pathname } = useLocation();

    if (HIDDEN_ROUTES.includes(pathname)) {
        return null;
    }

    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                <div className={styles.top}>
                    <AppDownload />
                    <FooterNav />
                </div>
                <div className={styles.divider} />
                <div className={styles.bottom}>
                    <SocialLinks />
                    <Copyright />
                </div>
            </div>
        </footer>
    );
};

export default Footer;